import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Light bulb — bulb body with a tapered base, two visible cap
 *  threads, and a small zig-zag filament inside. Means "idea /
 *  inspiration / insight" in the taxonomy picker. */
export function IcnLightbulb(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="lightbulb">
      {/* Bulb body */}
      <path d="M5 7.5 Q5 3 8 3 Q11 3 11 7.5 Q11 9.5 9.5 10.5 V11.5 H6.5 V10.5 Q5 9.5 5 7.5 Z" />
      {/* Filament */}
      <path d="M6.5 7.5 L7.5 9 L8.5 7.5 L9.5 9" />
      {/* Threads */}
      <path d="M6.5 12.5 H9.5" />
      <path d="M7 14 H9" />
    </Svg>
  );
}
